import { createStackNavigator } from "@react-navigation/stack";
import { PROFILE_ROUTES } from "./routes";
import { useSelector } from "react-redux";
import { RootState, dispatch } from "../redux/store";
import { useEffect } from "react";
import { getUserData } from "../services/Profile/profileService";
import Screens from "../screens";
import { useNavigation } from "@react-navigation/native";
import { Platform } from "react-native";
import { setNewUser } from "../redux/auth/authSlice";
import AsyncStorage from "@react-native-async-storage/async-storage";

const ProfileStack = createStackNavigator();

const steps: { [key: number]: string } = {
  1: PROFILE_ROUTES.ONBOARD_NAME,
  2: PROFILE_ROUTES.DATE_OF_BIRTH,
  3: PROFILE_ROUTES.ONBOARD_GENDER,

  4: PROFILE_ROUTES.ONBOARD_UPLOAD,
  5: PROFILE_ROUTES.SELECT_EXPERIENCE,
  6: PROFILE_ROUTES.COMPANY_ADD,
  7: PROFILE_ROUTES.SOCIAL_LINK_ADD,
  8: PROFILE_ROUTES.CITY_ADD,
  9: PROFILE_ROUTES.DATE_PREFERENCE
  // 9: PROFILE_ROUTES.USE_REASON,
};

const ProfileNavigationScreens = () => {
  const navigation = useNavigation();

  useEffect(() => {
    const handleUser = async () => {
      try {
        const res: any = await getUserData();
        if (res?.data?.data?.steps == 0) {
          // do nothing
        } else {
          if (res?.data?.data?.steps == 3) {
            navigation.navigate("more-details" as never);
          } else if (res?.data?.data?.steps >= Object.keys(steps).length) {
            if ((await AsyncStorage.getItem("hideStaticScreen")) === "true") {
              dispatch(setNewUser());
            } else {
              if (Platform.OS === "web") {
                navigation.navigate("onboar-alldone" as never);
              } else {
                navigation.navigate("grant-access" as never);
              }
            }
            // navigation.navigate("grant-access" as never);

          } else {
            navigation.navigate(steps[res?.data?.data?.steps + 1] as never);
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    handleUser();
  }, []);

  return (
    <ProfileStack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <ProfileStack.Screen
        name={PROFILE_ROUTES.BASIC_INFO}
        component={Screens.BasicInfo}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.ONBOARD_NAME}
        component={Screens.BasicInfo_Name}
      />

      <ProfileStack.Screen
        name={PROFILE_ROUTES.DATE_OF_BIRTH}
        component={
          Platform.OS === "web"
            ? Screens.BasicInfo_DateOfBirthWeb
            : Screens.BasicInfo_DateOfBirthApp
        }
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.MORE_DETAILS}
        component={Screens.MoreInfo}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.ONBOARD_GENDER}
        component={Screens.OnBoardingGender}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.DATE_PREFERENCE}
        component={Screens.DatePreferences}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.ONBOARD_UPLOAD}
        component={Screens.UploadProfileImages}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.SELECT_EXPERIENCE}
        component={Screens.SelectExperienceOnboarding}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.COMPANY_ADD}
        component={Screens.CompanyAdd}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.CITY_ADD}
        component={Screens.CityAdd}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.USE_REASON}
        component={Screens.UseReason}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.SOCIAL_LINK_ADD}
        component={Screens.SocialLinkAdd}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.ONBOARD_GRANTACCESS}
        // component={Screens.GrantLocationAccess}
        component={
          Platform.OS === "web"
            ? Screens.GrantLocationAccess
            : Screens.GrantLocationAccess
        }
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.ONBOARD_SUBSCRIBE}
        component={Screens.SubscribeOnboarding}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.ONBOARD_ALLDONE}
        component={Screens.OnBoardingComplete}
      />

      {/* 
      
      <ProfileStack.Screen
        name={PROFILE_ROUTES.ONBOARD_ALLDONE}
        component={Screens.AllDone}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.ONBOARD_FINDOUT}
        component={Screens.FindOut}
      />
      <ProfileStack.Screen
        name={PROFILE_ROUTES.ONBOARD_SUBSCRIBE}
        component={Screens.Subscribe}
      />
     */}
    </ProfileStack.Navigator>
  );
};

export default ProfileNavigationScreens;
